export enum ERouters {
  ADD = 'add',
  AIMS_TO_LABS = 'aims',
  BATCH_GENERATE_FIRST_PAGE = 'batch-generate-first-page',
  BATCH_GENERATE_FIRST_PAGE_ADD = 'batch-generate-first-page-add',
  CONFIRM_PARAMETERS = 'confirm-parameters',
  CPSC_EFILING = 'cpsc-efiling',
  CPSC_MAPPING = 'cpsc-mapping',
  CUSTOMIZE_SECTION = 'customize-section',
  DASHBOARD = 'dashboard',
  DETAIL = 'detail',
  EDIT = 'edit',
  EDIT_SPECIMEN = 'edit-specimen',
  EDIT_TEMPLATE = 'edit-template',
  FIRST_PAGE = 'first-page',
  FP_SINGLE_TEST_EDIT = 'fp-single-test-edit',
  GENERAL_INFO = 'general-info',
  GENERATE_BREAKDOWN = 'generate-breakdown-list',
  LAB_INFO = 'lab-info',
  LINKED_RESULT_TABLE = 'linked-result-table',
  MASTER_DATA = 'master-data',
  NO_RESULT_TABLE = 'no-result-table',
  ORDER_DETAIL = 'order-detail',
  OVERVIEW = 'overview',
  PARAMETER_INFO = 'parameter-info',
  PARAMETERS = 'parameters',
  REFERENCE_SPECIMEN = 'reference-specimen',
  REPORT_GENERATION = 'report-generation',
  REPORT_PREPARATION = 'report-preparation',
  SCAN = 'scan',
  TEMPLATE = 'template',
  TEST = 'test',
  TEST_APPROVAL = 'test-approval',
  TEST_DETAIL = 'test-detail',
  TEST_METHOD = 'test-method',
  TEST_PAGE = 'test-page',
  TEST_REJECT = 'test-reject',
  TEST_RESULT_APPROVAL_PREVIEW = 'test-result-approval-preview',
  TEST_RESULT_SETUP = 'test-result-setup',
  TEST_SET_UP = 'test-set-up',
  TO_DO_LIST = 'to-do-list',
  UPLOAD_RESULT_TABLE_FILE = 'upload-result-table-file',
  VIEW_SPECIMEN = 'view-specimen',
}
